var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2750_11253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 2.89157C19.5056 2.89157 2.89157 19.5056 2.89157 40C2.89157 60.4944 19.5056 77.1084 40 77.1084C60.4944 77.1084 77.1084 60.4944 77.1084 40C77.1084 19.5056 60.4944 2.89157 40 2.89157ZM0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2531 25.1133C39.3917 24.794 37.4774 25.1438 35.8492 26.1007C34.221 27.0576 32.984 28.5599 32.3572 30.3415C31.8992 31.6435 30.4725 32.3277 29.1705 31.8697C27.8685 31.4116 27.1843 29.9849 27.6423 28.6829C28.6607 25.7878 30.6708 23.3466 33.3167 21.7916C35.9625 20.2367 39.0733 19.6682 42.0981 20.1871C45.1229 20.7059 47.8664 22.2785 49.8428 24.6263C51.8189 26.9738 52.9006 29.9447 52.8964 33.0131C52.8953 37.8373 49.31 41.1127 46.5355 42.9624C45.0719 43.9381 43.6262 44.6592 42.5561 45.1347C42.0176 45.3741 41.5653 45.5552 41.2418 45.6784C41.0799 45.7401 40.9496 45.7875 40.8562 45.8207L40.7444 45.8599L40.7103 45.8715L40.6989 45.8754C40.6989 45.8754 40.6914 45.8779 39.9011 43.5071L40.6914 45.8779C39.382 46.3144 37.9668 45.6067 37.5303 44.2973C37.0942 42.9892 37.8001 41.5753 39.1072 41.1375L39.1181 41.1337L39.1818 41.1114C39.2422 41.0899 39.3374 41.0553 39.4625 41.0077C39.713 40.9123 40.0807 40.7653 40.5262 40.5674C41.4242 40.1682 42.6025 39.5773 43.763 38.8037C46.2361 37.1549 47.8982 35.1829 47.8982 33.0109C47.901 31.1223 47.2354 29.29 46.0191 27.8451C44.8029 26.4003 43.1145 25.4326 41.2531 25.1133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6825 57.5009C37.6825 56.1207 38.8014 55.0018 40.1816 55.0018H40.2166C41.5968 55.0018 42.7157 56.1207 42.7157 57.5009C42.7157 58.8811 41.5968 60 40.2166 60H40.1816C38.8014 60 37.6825 58.8811 37.6825 57.5009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2750_11253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/iconQuestion.28d8a07cbbaa16e58e417b0249cfa26b.svg";
export { ForwardRef as ReactComponent };